module.exports = __webpack_public_path__ + "static/media/chat.e7f352b6.svg";